import { type FC, memo } from 'react';
import type { SvgIconProps } from '@material-ui/core/SvgIcon';
import cx from 'classnames';

import { type GenerationTool } from 'src/data/generationTool';

import { useStyles } from './useStyles';
import { getGenerationToolIcon } from './utils';

interface Props {
  className?: string;
  classes?: Partial<ReturnType<typeof useStyles>>;
  tool: GenerationTool;
  /** Drawn in place of the tool's own icon, styled the same. */
  icon?: FC<SvgIconProps>;
}

export const GenerationToolIcon: FC<Props> = memo(({ className, classes, tool, icon }) => {
  const styles = useStyles({ classes });
  const Icon = icon || getGenerationToolIcon(tool);

  return <Icon className={cx(styles.root, className)} />;
});
